/**
 * Template: Index
 * -----------------------------------------------------------------------------
 * Scripts to execute on the index page.
 *
 */
import { load } from '@shopify/theme-sections';
import '~/sections/hero-banner';
import '~/sections/homepage-image-banner--triple';
import '~/sections/homepage-usps--carousel';
import '~/sections/newsletter-modal';
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});